const groupPrefix = 'bookings'

export const apiReservation = {
	calculateReservation: async (request: IReservationRequest, locale: string) => {
		// lang header
		let lang = 'en'
		if (locale === 'pl') {
			lang = 'pl'
		}

		// currency header
		const currency = useCookie('currency').value

		const { data } = await apiCommon<IReservationModel>(
			`${groupPrefix}/calculate`,
			{
				method: 'POST',
				body: request,
			},
			lang,
			currency || 'PLN',
		)

		return data
	},

	createRenteonReservation: async (request: IReservationCreateRequest, locale: string) => {
		// lang header
		let lang = 'en'
		if (locale === 'pl') {
			lang = 'pl'
		}

		const data = await apiCommon<IReservationCreateResponse>(
			`${groupPrefix}/save`,
			{
				method: 'POST',
				body: request,
			},
			lang,
		)

		return data as unknown as IReservationCreateResponse
	},

	fetchReservation: async (reservationID: string) => {
		const { data } = await apiCommon<IBooking>(`${groupPrefix}/${reservationID}`, {
			method: 'GET',
		})

		return Booking(data)
	},
}
